


























import Vue from "vue";
import SettingItem from "@/components/SettingItem.vue";
import { setLS } from "@/services";
import { StorageType } from "@/models/StorageType";

export default Vue.extend({
  components: {
    SettingItem,
  },

  data: () => ({
    initialName: "",
    initialAvatar: "",
  }),

  beforeMount(): void {
    this.initialName = this.$store.state.username || "";
    this.initialAvatar = this.$store.state.avatarUrl || "";
  },
  methods: {
    nameChange(newName: string): void {
      setLS(StorageType.USERNAME, newName);
    },
    avatarChange(newLink: string): void {
      setLS(StorageType.AVATARURL, newLink);
    },
    placeChange(newPlace: string) {
      setLS(StorageType.PLACE, newPlace);
    },
  },
  computed: {
    initialPlace(): string {
      return this.$store.state.place || "";
    },
  },
});
